import React from 'react'
import { Routes, Route } from 'react-router'
import ContRoutes from '../const/const-router'

const AuthRoute = () => {
  return (
    <Routes>
      {ContRoutes?.map((e) => (
        <Route
          key={e.path}
          index={e.index}
          path={e.path}
          element={e.component}
        />
      ))}
    </Routes>
  )
}

export default AuthRoute
